import React, {useEffect, useState} from "react";
import classes from "./ActionsList.module.css"
import {Button} from "primereact/button";
import {isAuthorized} from "../../../api/authorization/authorization-service";
import {isClosed} from "../../../api/dataCollection/dataCollection-status";
import CoordinationDialog from "../../DataCollectionDetails/Coordination/CoordinationDialog";
import {getCoordinations} from "../../../api/Coordination/coordination-service";

const Actions = (props) => {
    const [mnData, setMnData] = useState(null);
    const [isCoordinationButtonVisible, setIsCoordinationButtonVisible] = useState(false);
    const [warningMsg, setWarningMsg] = useState("Don't forget to publish your data after validation");
    const publishAuthorizationRoleVisibilityBtn = isAuthorized("AR013")
        ? (<Button className={classes.actionBtn}
                   disabled={ ((!isAuthorized("AR08") && !isAuthorized("AR38") && isClosed(props.dataCollection.status)) || props.btnPublishVisibility || props.statusLV4 || props.shouldLockUpload)}
                   onClick={props.onPublishClick}
                   label={props.publishBtnLabel}
                   loading={props.publishBtnLabel === props.persistingLabel}
            />
        ) : null

    const validateAllAuthorizationRoleVisibilityBtn = isAuthorized("AR013") && props.uploadMethod !== "zip-xml" && props.haveMultipleCategories
        ? (
            <Button className={classes.actionBtn}
                    label="Validate all Data"
                    loading={props.statusLV4}
                    disabled={(!isAuthorized("AR08") && isClosed(props.dataCollection.status) && !isAuthorized("AR38")) ||
                        props.validationButtonDisabled || props.marketNodeDataIsPublishing || props.shouldLockUpload}
                    onClick={props.onValidateAllDataClick}/>

        ) : null

    useEffect(() => {

        if (props.isCoordinationDataCollection === true && props.marketNodeData !== null && props.marketNodeData !== undefined) {
            getCoordinations(props.marketNodeData?.id).then(r => {
                if (r.content.length > 0) {
                    setIsCoordinationButtonVisible(true)
                }
            })
        }

    }, [props.marketNodeData, props.isCoordinationDataCollection]);


    const coordinationButton = isAuthorized("AR013") && props.isCoordinationDataCollection
        ? (
            <Button icon="pi pi-table" className={classes.actionBtn} visible={isCoordinationButtonVisible}
                    onClick={() => {
                        props.setIsCoordinationPopupVisible(true);
                        setMnData(props.marketNodeData);
                    }}></Button>
        ) : null
    const isPublishButtonEnabled = !((!isAuthorized("AR08") &&
        isClosed(props.dataCollection.status)) || props.btnPublishVisibility || props.statusLV4 || props.isValidation5InProgress);

    useEffect(() => {
            if (props.shouldLockUpload) {
                setWarningMsg("Validation is locked ! A cross TSOs validation is launched with your data")
            } else if (isPublishButtonEnabled) {
                setWarningMsg("Don't forget to publish your data after validation")
            }
        }
        , [props.shouldLockUpload]);
    return (
        <div className="grid p-0 m-0">
            <div className="col-8"/>

            <div className="col-4 flex flex-row-reverse flex-wrap card-container">
                {props.notifToFixErrors.isNotifVisible && (<div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: '#f8efdd',
                            border: '1px solid #ffeeba',
                            borderRadius: '8px',
                            padding: '10px 14px',
                            marginBottom: '10px',
                            color: '#a37513',
                            fontSize: '0.9rem',
                            width: '100%',
                        }}>
                        <i className="pi pi-exclamation-triangle" style={{fontSize: '1.1rem', marginRight: '10px'}}/>
                        <span>
  Please review and update your data, as <strong>{props.notifToFixErrors.requesters}</strong> has submitted a request to correct it.
</span>
                    </div>
                )
                }

                {publishAuthorizationRoleVisibilityBtn}
                {validateAllAuthorizationRoleVisibilityBtn}
                {coordinationButton}
                {(isPublishButtonEnabled || props.shouldLockUpload) && (
                    <div className="col-12 flex align-items-center justify-content-end">
                        <span className={`pi pi-exclamation-triangle ${classes.warningFlag}`}/>
                        <small className={classes.small}>
                            {warningMsg}
                        </small>
                    </div>
                )}

            </div>
            {props.isCoordinationDataCollection === true && (
                <CoordinationDialog
                    isCoordinationPopupVisible={props.isCoordinationPopupVisible}
                    marketNodeData={mnData}
                    dcId={props.dataCollection.id}
                    hidePopup={() => props.setIsCoordinationPopupVisible(false)}
                />
            )}
        </div>

    )

}

export default Actions;
